<template>
  <div class="forgot card">
    <h2>Forgot password</h2><br>

    <form @submit.prevent="submit">
      <input type="email" required placeholder="Email" v-model="forgotPasswordForm.email"><br>

      <button type="submit" :disabled="running">Submit</button><br><br><br>

      <div class="error" v-show="error">{{ error }}</div>

      <div>
        <span>Just kidding,</span>
        <router-link to="/login">login</router-link>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      forgotPasswordForm: {
        email: '',
      },
      error: '',
      running: false,
    };
  },

  methods: {
    submit() {
      this.error = '';
      this.running = true;

      this.$firebase.auth()
        .sendPasswordResetEmail(this.forgotPasswordForm.email)
        .then(() => {
          this.error = '';
          this.forgotPasswordForm.email = '';
          this.running = false;

          this.$toast({ message: 'An email has been sent to you to reset your password' });
        })
        .catch((err) => {
          this.error = err.message;
          this.forgotPasswordForm.email = '';
          this.running = false;
        });
    },
  },
};
</script>

<style lang="scss" rel="stylesheet/scss" type="text/scss" scoped>
  .forgot {
    @include centerContainer;
  }

  .error,
  .success {
    margin-bottom: $gp;
  }
</style>
